import { Component, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactModalComponent } from '../../components/contact-modal/contact-modal.component';
import { FadeInDirective } from '../../directives/fade-in.directive';


@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [CommonModule, ContactModalComponent, FadeInDirective]
})
export class HomeComponent {
  showMore: boolean = false;
  showContactModal = false;

  @ViewChild('moreSection') moreSection!: ElementRef<HTMLDivElement>;

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  toggleMore(): void {
    this.showMore = !this.showMore;

    setTimeout(() => {
      const section = this.moreSection?.nativeElement;
      if (!section) return;

      if (this.showMore) {
        section.style.maxHeight = section.scrollHeight + 'px';
        section.classList.add('expanded');
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        section.style.maxHeight = section.scrollHeight + 'px'; // ← potrzebne przed triggerem
        // odczekaj jedną klatkę, by animacja zadziałała
        requestAnimationFrame(() => {
          section.style.maxHeight = '0';
          section.classList.remove('expanded');
        });
      }
    }, 50);
  }

  scrollTo(id: string, event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    const element = document.getElementById(id);
    if (element) {
      const yOffset = id === 'juno' ? -200 : -100;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

}